'use strict';

class GifrAdminView {
  constructor() {
    'ngInject';
  }
}

export default GifrAdminView;
